import KeyEnum = Boo.Objects.Enums.KeyEnum;
import WorkflowKeyValuePair = Boo.Objects.WorkflowKeyValuePair;

export default class WorkflowHelper {
  static getWorkflowKeyValuePair(workflowKeyValuePairs: WorkflowKeyValuePair[], key: KeyEnum): WorkflowKeyValuePair {
    return _.find(_.sortBy(workflowKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
  }

  static get<Type>(workflowKeyValuePairs: WorkflowKeyValuePair[], key: KeyEnum): Type {
    return WorkflowHelper.getValue(workflowKeyValuePairs, key) as unknown as Type;
  }

  static getJSON<Type>(workflowKeyValuePairs: WorkflowKeyValuePair[], key: KeyEnum): Type {
    const value = WorkflowHelper.getValue(workflowKeyValuePairs, key);
    return value ? JSON.parse(value) as unknown as Type : null;
  }

  static getValue(workflowKeyValuePairs: WorkflowKeyValuePair[], key: KeyEnum): string {
    const kvp = _.find(_.sortBy(workflowKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
    return kvp ? kvp.KeyValuePair.Value : '';
  }

  static setJSON(workflowKeyValuePairs: WorkflowKeyValuePair[], workflowId: number, key: KeyEnum, value: any): void {
    WorkflowHelper.setValue(workflowKeyValuePairs, workflowId, key, JSON.stringify(value));
  }

  static setValue(workflowKeyValuePairs: WorkflowKeyValuePair[], workflowId: number, key: KeyEnum, value: string): void {
    let kvp = _.find(_.sortBy(workflowKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
    if (kvp && kvp.KeyValuePair) {
      kvp.KeyValuePair.Value = value;
    } else {
      kvp = this.workflowKvpFactory(workflowId, value, key);
      workflowKeyValuePairs.push(kvp);
    }
  }

  private static workflowKvpFactory(workflowId: number, value: string, key: KeyEnum): WorkflowKeyValuePair {
    return {
      WorkflowId: workflowId,
      WorkflowKeyValuePairId: 0,
      InsertedDate: null,
      KeyValuePair: {
        Key: {
          KeyId: key
        } as Boo.Objects.Key,
        KeyId: key,
        KeyValuePairId: 0,
        Value: value
      },
      KeyValuePairId: 0
    };
  }
}

